import { showField, showFieldNew } from 'utils/form';
import { InputType } from 'generated/graphql';
import { getFieldRenderer } from './fieldRenderers';
import type { DynamicInputFieldProps, FieldRendererProps } from './types';

export function DynamicInputField(props: DynamicInputFieldProps) {
  const { field, allFields, disabled = false, hasWhiteFields = false } = props;

  const isDisabled = !!(!field || field.disabled || disabled);
  const isReadOnly = !!field.readOnly;

  // Hide fields whose ShowIf/ShowIfs say they shouldn't render.
  if (field.type === InputType.Hidden || !showFieldNew(field, allFields) || !showField(field, allFields)) {
    return null;
  }

  const rendererProps: FieldRendererProps = {
    ...props,
    hasWhiteFields,
    isDisabled,
    isReadOnly,
  };

  const Renderer = getFieldRenderer(field.type);
  return <Renderer {...rendererProps} />;
}
